const GRAPHQLHOST = 'https://cam-eivy.ddns.net/casapi';
const SERIES_SEQUENCE_ORDER = new Array(
	"iPhone15Series",
	"iPhone14Series",
	"iPhone13Series",
	"iPhone12Series",
	"iPhone11Series",
	"iPhoneSESeries",
	"iPhoneXRSeries",
	"iPhoneXSSeries",
	"iPhoneXSeries",
	"iPhone8Series",
	"iPhone7Series",
	"GalaxyS24Series",
	"GalaxyS23Series",
	"GalaxyS22Series",
	"GalaxyS21Series",
	"GalaxyS20Series",
	"GalaxyS10Series",
	"GalaxyNoteSeries",
	"GalaxyASeries",
	"GalaxyZFlipSeries",
	"GalaxyZFoldSeries",
	"XiaomiSeries",
	"BlackSharkSeries",
	"MiSeries",
	"PocoSeries",
	"RedmiSeries",
	"RenoSeries",
	"FindSeries",
	"ASeries",
	"MateSeries",
	"NovaSeries",
	"PSeries",
	"YSeries",
	"iPad",
	"iPadAir",
	"iPadMini",
	"iPadPro",
	"GalaxyTabSSeries",
	"GalaxyTabASeries",
	"WatchSeries9",
	"WatchSeries8",
	"WatchSeries7",
	"WatchSeries6",
	"WatchSeries5",
	"WatchSeries4",
	"WatchSeries3",
	"WatchSeries2",
	"WatchSeriesSE",
	"WatchSeriesUltra",
	"GalaxyWatch6",
	"GalaxyWatch5",
	"GalaxyWatch4",
	"GalaxyWatch3",
	"GalaxyWatchActive",
	"GalaxyWatch6",
	"MacMini",
	"MacStudio",
	"MacbookAir",
	"MacbookPro"
);
let originProduct = [];

function copyCode(el, reserveText = false) {
  var temp = document.createElement("input");
  document.body.appendChild(temp);
  temp.value = el.value;
  temp.select();

  var res = document.execCommand("copy");
  document.body.removeChild(temp);
  el.textContent = "COPIED";
  setTimeout(() => {
    if (reserveText) {
      el.innerHTML = el.dataset.text;
    } else {
      el.innerHTML = '<strong>' + el.value + '</strong>';
    }
  }, "3000");
}

function togglePanelVisible(item) {
    var mainElement = document.getElementById('main');
    if (item.style.display === 'none') {
        var div = document.createElement('div');
        div.id = 'pa-overlay';
        mainElement.prepend(div);
        return item.style.display = 'block';
    } else {
        document.getElementById('pa-overlay').remove();
        return item.style.display = 'none';
    }
};

function offPanel(item) {
    if (document.getElementById('pa-overlay')) {
        document.getElementById('pa-overlay').remove();
    }
    return item.style.display = 'none';
}

function menuHandler(index) {
    var panels = document.getElementsByClassName("pa-dropdown-panel");

    if (panels[index].style.display == 'block') {
        togglePanelVisible(panels[index]);
    } else {
        for (var j = 0; j < panels.length; j++) {
            if (index != j) {
                offPanel(panels[j]);
            }
        }
    
        togglePanelVisible(panels[index]);
    }
}

/* var dropdownTriggers = document.getElementsByClassName("pa-dropdown-trigger");
for (var i = 0; i < dropdownTriggers.length; i++) {
    (function(index) {
        dropdownTriggers[index].addEventListener('hover', function(itm) {
            menuHandler(index);
            togglePanelVisible(dropdownTriggers[index]);
        });
    })(i);
} */

var dropdownTriggers = document.querySelectorAll('[data-action="dropdown"]');
for (var i = 0; i < dropdownTriggers.length; i++) {
  (function(index) {
    dropdownTriggers[index].addEventListener('click', function(itm) {
      itm.stopPropagation();

      document.querySelectorAll('[data-dropdown="panel"]').forEach(v => {
        if (v.style.display != 'none') {
          v.style.display = 'none';
        }
      });

      let dropdownMenu = dropdownTriggers[index].nextElementSibling;
      dropdownMenu.style.display = 'block';
    });
  })(i);
}

// var accordion = document.getElementsByClassName("pa-accordion");
// for (var i = 0; i < accordion.length; i++) {
//   accordion[i].addEventListener("click", function() {
//     this.classList.toggle("active");

//     var panel = this.nextElementSibling;
//     if (panel.style.display === "block") {
//       panel.style.display = "none";
//     } else {
//       panel.style.display = "block";
//     }
//   });
// }

function setTitleLabel(element, cat, value) {
  if (element) {
    const selectedButton = document.querySelector('.pa-dropdown-panel.pa-dropdown-on button.pa-' + cat + '-btn[value=\'' + value + '\']');
    selectedButton.classList.toggle('active');

    if (selectedButton.classList.contains('active')) {
      if (cat == 'series' || cat == 'model') {
        document.getElementById('pa-menu-label_'+element+'_series').innerText = value;
      } else {
        document.getElementById('pa-menu-label_'+element+'_'+cat).innerText = value;
      }

      if (value != 'All') {
        if (cat == 'brand') {
          showMenuTagSelected('BRAND_' + selectedButton.value, selectedButton.value);
        } else {
          showMenuTagSelected(selectedButton.dataset.tag, selectedButton.value);
        }
      }
    } else {
      if (cat == 'series' || cat == 'model') {
        document.getElementById('pa-menu-label_'+element+'_series').innerText = '';
      } else {
        document.getElementById('pa-menu-label_'+element+'_'+cat).innerText = '';
      }

      if (value != 'All') {
        if (cat == 'brand') {
          document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa_menu_js_tag-brand_' + value.toLowerCase()).remove();
        } else {
          // document.querySelector('.pa-dropdown-panel[aria-hidden="false"] .pa_menu_js_tag-' + selectedButton.dataset.tag.toLowerCase().replaceAll(' ', '-').replaceAll(/\./g, '-')).remove();
          document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa_menu_js_tag-' + escapeTag(selectedButton.dataset.tag.toLowerCase())).remove();
        }
      }
    }
  }
}

document.querySelectorAll('.pa-filter-brand-container button').forEach(button => {
  button.addEventListener('click', async (evt) => {
    setTitleLabel(button.dataset.type, 'brand', button.value);

    document.querySelectorAll('.pa-dropdown-panel.pa-dropdown-on .pa-filter-brand-container button[value]:not([value="' + button.value + '"])').forEach(v => {
      if (v) {
        v.classList.remove('active');

        const nonSpaceTag = ('brand_' + v.value).toLowerCase().replace(' ', '-');
        if (document.querySelector('.pa_menu_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_menu_js_tag-' + nonSpaceTag).remove();
        }
      }
    });

    if (!document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-brand-container button.active')) {
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_brand').innerText = 'All';
    }

    const seriesTag = document.querySelector('.pa-dropdown-panel.pa-dropdown-on button[class*="pa_menu_js_tag-models"]');
    if (seriesTag) {
      document.getElementById('pa-menu-label_' + button.dataset.type + '_series').innerText = '';
      seriesTag.remove();
    }
    const modelTag = document.querySelector('.pa-dropdown-panel.pa-dropdown-on button[class*="pa_menu_js_tag-models2"]');
    if (modelTag) {
      document.getElementById('pa-menu-label_' + button.dataset.type + '_series').innerText = '';
      modelTag.remove();
    }

    const collection = document.querySelector('.pa-dropdown-panel.pa-dropdown-on').dataset.collection;
    if (collection && button.classList.contains('active')) {
      const specificCollection = button.dataset.collectionPath.replace('/collections/','');
      const collectionQuery = await getMenuCollectionConditions(specificCollection);
      let productData = await getProductTag(collectionQuery + ' AND vendor:' + button.value);
      originProduct = productData;

      const seriesData = [];
      const modelData = [];
      productData.forEach(j => {
        if (j.indexOf('BRANDS_' + button.value) != -1) {
          j.forEach(v => {
            let tag_parts = v.split('_');
            let first = tag_parts[0];
            if (first.toLowerCase() == 'models' && seriesData.indexOf(v) == -1) {
              seriesData.push(v);
            } else if (first.toLowerCase() == 'models2' && modelData.indexOf(v) == -1) {
              modelData.push(v);
            }
          });
        }
      });

      let htmlSeriesElement = document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-group');
      while (htmlSeriesElement.firstChild) { 
        htmlSeriesElement.removeChild(htmlSeriesElement.firstChild);
      }
      if (!seriesData.length) {
        document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-container').classList.add('pa-disabled');
      } else {
        document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-container').classList.remove('pa-disabled');

        htmlSeriesElement.insertAdjacentHTML('beforeend', `<button type="button" class="pa-series-btn active" value="All" data-type="${button.dataset.type}" data-tag="">All</button>`);
        seriesData.forEach(v => {
          const readableTag = v.split('_');
          let indexOfSequence = 0;
          let correctFormatting = v.toLowerCase().replaceAll(' ', '-');
  
          if (SERIES_SEQUENCE_ORDER.indexOf(readableTag[readableTag.length-1].replaceAll(' ', '')) != -1) {
            indexOfSequence = SERIES_SEQUENCE_ORDER.indexOf(readableTag[readableTag.length-1].replaceAll(' ', ''));
          }
  
          let seriesTemplate = `<button type="button" class="pa-series-btn" value="${readableTag[readableTag.length - 1]}" data-type="${button.dataset.type}" data-tag="${v}" style="order: ${indexOfSequence}">${readableTag[readableTag.length - 1]}</button>`;
          htmlSeriesElement.insertAdjacentHTML('beforeend', seriesTemplate);
        });

        setSeriesEvent();
      }

      let htmlModelElement = document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-model-group');
      while (htmlModelElement.firstChild) { 
        htmlModelElement.removeChild(htmlModelElement.firstChild);
      }
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-model-container').classList.add('pa-disabled');
      /* if (!modelData.length) {
        document.querySelector('.pa-dropdown-panel[aria-hidden="false"] .pa-filter-model-container').classList.add('pa-disabled');
      } else {
        document.querySelector('.pa-dropdown-panel[aria-hidden="false"] .pa-filter-model-container').classList.remove('pa-disabled');

        htmlModelElement.insertAdjacentHTML('beforeend', `<button type="button" class="pa-model-btn" value="All" data-type="${button.dataset.type}" data-tag="">All</button>`);
        modelData.sort().forEach(v => {
          const readableTag = v.split('_');
          let indexOfSequence = 0;
          let correctFormatting = v.toLowerCase().replaceAll(' ', '-');
  
          if (SERIES_SEQUENCE_ORDER.indexOf(readableTag[readableTag.length-1].replaceAll(' ', '')) != -1) {
            indexOfSequence = SERIES_SEQUENCE_ORDER.indexOf(readableTag[readableTag.length-1].replaceAll(' ', ''));
          }
  
          let modelTemplate = `<button type="button" class="pa-model-btn" value="${readableTag[readableTag.length - 1]}" data-type="${button.dataset.type}" data-tag="${v}" style="order: ${indexOfSequence}">${readableTag[readableTag.length - 1]}</button>`;
          htmlModelElement.insertAdjacentHTML('beforeend', modelTemplate);
        });

        setModelEvent();
      } */

      document.querySelector('.pa-dropdown-on button[aria-controls="filter-series"]').click();
      // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
      // document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + productData.length + (productData.length > 1 ? ' items' : ' item');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
    } else {
      originProduct = [];
      let count = await menuProductCount();
      // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
      // document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
    }
  });
});

function setSeriesEvent() {
  document.querySelectorAll('.pa-filter-series-group button').forEach(button => {
    button.addEventListener('click', async () => {
      setTitleLabel(button.dataset.type, 'series', button.value);

      document.querySelectorAll('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-group button[value]:not([value="' + button.value + '"])').forEach(v => {
        if (v) {
          v.classList.remove('active');

          const nonSpaceTag = v.dataset.tag.toLowerCase().replaceAll(' ', '-');
          if (document.querySelector('.pa_menu_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_menu_js_tag-' + nonSpaceTag).remove();
          }
        }
      });

      const resetModelTag = document.querySelector('.pa-dropdown-panel.pa-dropdown-on .filters-result [class*="pa_menu_js_tag-models2"]');
      if (resetModelTag) {
        resetModelTag.remove();
      }

      if (!document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-container button.active')) {
        document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-container button[value="All"]').classList.add('active');
        document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_series').innerText = 'All';
      }

      let modelData = [];
      if (originProduct.length) {
        originProduct.forEach(j => {
          if (j.indexOf(button.dataset.tag) != -1) {
            j.forEach(v => {
              let tag_parts = v.split('_');
              let first = tag_parts[0];
  
              if (first.toLowerCase() == 'models2' && modelData.indexOf(v) == -1) {
                modelData.push(v);
              }
            });
          }
        });
      } else {
        // load from GraphQl to get model Data
        const collection = document.querySelector('.pa-dropdown-panel.pa-dropdown-on').dataset.collection;
        if (collection && button.classList.contains('active')) {
          const collectionQuery = await getMenuCollectionConditions(collection);
          let productData = await getProductTag(collectionQuery + ' AND tag:' + button.dataset.tag);
          productData.forEach(v => {
            v.forEach(j => {
              if (j.toLowerCase().includes('models2')) {
                modelData.push(j);
              }
            });
          });
        } else {
          return;
        }
      }

      let htmlModelElement = document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-model-group');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-model-container').classList.remove('pa-disabled');
      while (htmlModelElement.firstChild) { 
        htmlModelElement.removeChild(htmlModelElement.firstChild);
      }
      if (document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-container button.active[value="All"]')) {
        htmlModelElement.insertAdjacentHTML('beforeend', `<button type="button" class="pa-model-btn active" value="All" data-type="${button.dataset.type}" data-tag="">All</button>`);
      } else {
        htmlModelElement.insertAdjacentHTML('beforeend', `<button type="button" class="pa-model-btn" value="All" data-type="${button.dataset.type}" data-tag="">All</button>`);
      }
      modelData.sort().forEach(v => {
        const readableTag = v.split('_');
        let indexOfSequence = 0;
        let correctFormatting = v.toLowerCase().replaceAll(' ', '-');

        if (SERIES_SEQUENCE_ORDER.indexOf(readableTag[readableTag.length-1].replaceAll(' ', '')) != -1) {
          indexOfSequence = SERIES_SEQUENCE_ORDER.indexOf(readableTag[readableTag.length-1].replaceAll(' ', ''));
        }

        let modelTemplate = `<button type="button" class="pa-model-btn" value="${readableTag[readableTag.length - 1]}" data-type="${button.dataset.type}" data-tag="${v}" style="order: ${indexOfSequence}">${readableTag[readableTag.length - 1]}</button>`;
        htmlModelElement.insertAdjacentHTML('beforeend', modelTemplate);
      });

      setModelEvent();

      let count = await menuProductCount();
      // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
      // document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
    });
  });
}
setSeriesEvent();

function setModelEvent() {
  document.querySelectorAll('.pa-filter-model-group button').forEach(button => {
    button.addEventListener('click', async () => {
      let productCount = 0;
      const selectedSeries = document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-series-btn.active');
      setTitleLabel(button.dataset.type, 'model', button.value);

      document.querySelectorAll('.pa-dropdown-panel.pa-dropdown-on .pa-filter-model-group button[value]:not([value="' + button.value + '"])').forEach(v => {
        if (v) {
          v.classList.remove('active');

          const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '-');
          if (document.querySelector('.pa_menu_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_menu_js_tag-' + nonSpaceTag).remove();
          }
        }
      });

      if (!document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-model-container button.active')) {
        document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-model-container button[value="All"]').classList.add('active');
        if (document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-container button.active')) {
          document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_series').innerText = document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-series-container button.active').value;
        } else {
          document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_series').innerText = 'All';
        }
      }

      let count = await menuProductCount();
      // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
      // document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
    });
  });
}
setModelEvent();

document.querySelectorAll('.pa-filter-capacity-container button').forEach(button => {
  button.addEventListener('click', async () => {
    setTitleLabel(button.dataset.type, 'capacity', button.value);

    document.querySelectorAll('.pa-dropdown-panel.pa-dropdown-on .pa-filter-capacity-container button[value]:not([value="' + button.value + '"])').forEach(v => {
      if (v) {
        v.classList.remove('active');

        const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '-');
        if (document.querySelector('.pa_menu_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_menu_js_tag-' + nonSpaceTag).remove();
        }
      }
    });

    if (!document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-capacity-container button.active')) {
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-capacity-container button[value="All"]').classList.add('active');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_capacity').innerText = 'All';
    }
  
    let count = await menuProductCount();
    // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
    document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
    //document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
  });
});

document.querySelectorAll('.pa-filter-size-container button').forEach(button => {
  button.addEventListener('click', async () => {
    setTitleLabel(button.dataset.type, 'size', button.value.replace('"', '\"'));

    document.querySelectorAll('.pa-dropdown-panel.pa-dropdown-on .pa-filter-size-container button[value]:not([value=\'' + button.value.replace('"', '\"') + '\'])').forEach(v => {
      if (v) {
        v.classList.remove('active');

        const nonSpaceTag = escapeTag(v.dataset.tag.toLowerCase()); // v.dataset.tag.toLowerCase().replace(' ', '-').replaceAll(/\./g, '-');
        if (document.querySelector('.pa_menu_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_menu_js_tag-' + nonSpaceTag).remove();
        }
      }
    });

    if (!document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-size-container button.active')) {
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-size-container button[value="All"]').classList.add('active');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_size').innerText = 'All';
    }

    let count = await menuProductCount();
    // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
    // document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
    document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
  });
});

document.querySelectorAll('.pa-filter-cosmetic-grading-container button').forEach(button => {
  button.addEventListener('click', async () => {
    setTitleLabel(button.dataset.type, 'cosmetic-grading', button.value);

    document.querySelectorAll('.pa-dropdown-panel.pa-dropdown-on .pa-filter-cosmetic-grading-container button[value]:not([value="' + button.value + '"])').forEach(v => {
      if (v) {
        v.classList.remove('active');

        const nonSpaceTag = v.dataset.tag.toLowerCase().replaceAll(' ', '-');
        if (document.querySelector('.pa_menu_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_menu_js_tag-' + nonSpaceTag).remove();
        }
      }
    });

    if (!document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-cosmetic-grading-container button.active')) {
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-cosmetic-grading-container button[value="All"]').classList.add('active');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_cosmetic-grading').innerText = 'All';
    }

    let count = await menuProductCount();
    // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
    // document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
    document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
  });
});

document.querySelectorAll('.pa-filter-colour-container button').forEach(button => {
  button.addEventListener('click', async () => {
    setTitleLabel(button.dataset.type, 'colour', button.value);

    document.querySelectorAll('.pa-dropdown-panel.pa-dropdown-on .pa-filter-colour-container button[value]:not([value="' + button.value + '"])').forEach(v => {
      if (v) {
        v.classList.remove('active');

        const nonSpaceTag = v.dataset.tag.toLowerCase().replaceAll(' ', '-');
        if (document.querySelector('.pa_menu_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_menu_js_tag-' + nonSpaceTag).remove();
        }
      }
    });

    if (!document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-colour-container button.active')) {
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-colour-container button[value="All"]').classList.add('active');
      document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_colour').innerText = 'All';
    }

    let count = await menuProductCount();
    // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
    // document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
    document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
  });
});

document.querySelectorAll('.pa-filter-btn').forEach(button => {
  button.addEventListener('click', async() => {
    let params = '', url = '';
    const openMenu = document.querySelector('.pa-dropdown-panel.pa-dropdown-on');
    const selectedBrand = document.querySelector('.pa-dropdown-panel.pa-dropdown-on button.active.pa-brand-btn');
    if (selectedBrand) {
      url = selectedBrand.dataset.collectionPath;
    } else {
      url = '/collections/' + openMenu.dataset.handle;
    }
    
    document.querySelectorAll('.pa-dropdown-panel.pa-dropdown-on button.active[class]:not([class*="pa-brand-btn"]):not([value="All"])').forEach(v => {
      if (params == ''){
        params = v.dataset.tag.toLowerCase().replaceAll(' ', '-');
      } else {
        params += '+' + v.dataset.tag.toLowerCase().replaceAll(' ', '-');
      }
    });

    const minRange = openMenu.querySelector('#filter-budget .menu-range-input .menu-min-range');
    const maxRange = openMenu.querySelector('#filter-budget .menu-range-input .menu-max-range');
    if (minRange.value != minRange.getAttribute('value') || maxRange.value != maxRange.getAttribute('value')) {
      if (params.includes('?')) {
        params += '&filter.v.price.gte=' + minRange.value + '&filter.v.price.lte=' + maxRange.value;
      } else {
        params += '?filter.v.price.gte=' + minRange.value + '&filter.v.price.lte=' + maxRange.value;
      }
    }

    window.location.href = url + '/' + params;
  });
});

document.querySelectorAll('.pa-dropdown-panel').forEach(dropdown => {
  dropdown.querySelector('.pa-reset-btn').addEventListener('click', async() => {
    const htmlElement = dropdown.querySelector('.filters-result');
    dropdown.querySelectorAll('button.active').forEach(button => {
      const cat = button.classList.value.replace('pa-', '').replace('-btn', '').replace('active', '').trim();
      if (cat == 'brand') {
        originProduct = [];
      }
      setTitleLabel(button.dataset.type, cat, button.value);

      if (cat == 'series' || cat == 'model') {
        document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_series').innerText = 'All';
      } else {
        document.querySelector('.pa-dropdown-panel.pa-dropdown-on #pa-menu-label_' + button.dataset.type + '_' + cat).innerText = 'All';
      }

      const allBtn = document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-' + cat + '-btn[value="All"]');
      if (allBtn) {
        allBtn.classList.add('active');
      }
    });

    const minRange = dropdown.querySelector('#filter-budget .menu-range-input .menu-min-range');
    minRange.setAttribute('value', minRange.min);
    minRange.value = minRange.min;
    const maxRange = dropdown.querySelector('#filter-budget .menu-range-input .menu-max-range');
    maxRange.setAttribute('value', maxRange.max);
    maxRange.value = maxRange.max;

    const rangeValue = dropdown.querySelector(".menu-slider-container .menu-price-slider");
    let minVal = minRange.value;
    let maxVal = maxRange.value;
    rangeValue.style.left = `${(minVal / minRange.max) * 100}%`;
    rangeValue.style.right = `${100 - (maxVal / maxRange.max) * 100}%`;

    while (htmlElement.firstChild) { 
      htmlElement.removeChild(htmlElement.firstChild);
    }

    let count = await menuProductCount();
    // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
    // document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
    document.querySelector('.pa-dropdown-panel.pa-dropdown-on .pa-filter-btn').innerText = 'View results';
  });
});

async function menuProductCount() {
  const openMenu = document.querySelector('.pa-dropdown-panel.pa-dropdown-on');
  const selectedFilter = openMenu ? openMenu.querySelectorAll('.pa-accordion-content button.active:not([class*="pa-brand-btn"])') : [];
  const selectedBrandFilter = openMenu ? openMenu.querySelector('.pa-brand-btn.active') : [];
  let productCount = 0;

  if (originProduct.length) {
    let selectedFilterArr = [];
    if (selectedBrandFilter) {
      selectedFilterArr.push('BRANDS_' + selectedBrandFilter.value);
    }
    selectedFilter.forEach(v => {
      if (v.dataset.tag) {
        selectedFilterArr.push(v.dataset.tag)
      }
    });

    originProduct.forEach(v => {
      let correctCountTemp = 0;
      v.forEach(j => {
        if (selectedFilterArr.indexOf(j) != -1) {
          correctCountTemp++;
        }
      });

      if (correctCountTemp == selectedFilterArr.length) {
        productCount++;
      }
    });
  } else {
    const collection = openMenu ? openMenu.dataset.collection : '';
    if (collection) {
      let query = '';
      selectedFilter.forEach(v => {
        if (v.dataset.tag) {
          if (query == '') {
            query = 'tag:' + v.dataset.tag;
          } else {
            query += ' AND tag:' + v.dataset.tag;
          }
        }
      });

      const minRange = openMenu.querySelector('#filter-budget .menu-range-input .menu-min-range');
      const maxRange = openMenu.querySelector('#filter-budget .menu-range-input .menu-max-range');
      if (minRange.value > minRange.min || maxRange.value < maxRange.max && maxRange.value != 100) {
        if (query == '') {
          query += 'price:>=' + minRange.value + ' AND price:<=' + maxRange.value;
        } else {
          query += ' AND price:>=' + minRange.value + ' AND price:<=' + maxRange.value;
        }
      }

      const collectionQuery = await getMenuCollectionConditions(collection);
      productCount = await getProductCount(collectionQuery + (query ? ' AND ' + query : ''));
    }
  }

  return productCount;
}

async function getMenuCollectionConditions(collection = '') {
  let queryStr = [];
  let isHandle = !collection.match(/[A-Z]/) || collection.includes('-');
  let gqlParams = '';

  if (collection) {
    if (isHandle) {
      gqlParams = 'handle:' + collection;
    } else {
      gqlParams = 'title:' + collection;
    }
    const query = `
      {
        collections(
          query: "${gqlParams}"
          first: 50
        ) {
          nodes {
            products(first: 200) {
              pageInfo {
                hasNextPage
              }
              edges {
                node {
                  id
                }
              }
            }
            ruleSet {
              appliedDisjunctively
              rules {
                column
                condition
                conditionObject {
                  ... on CollectionRuleTextCondition {
                    value
                  }
                }
                relation
              }
            }
          }
        }
      }
    `;

    const response = await fetch(GRAPHQLHOST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    const result = await response.json();
    const data = result.data.collections.nodes[0].ruleSet;

    if (data && isRuleAvailable(data.rules)) {
      // Collection type: Automated 
      const condition = result.data.collections.nodes[0].ruleSet?.appliedDisjunctively;
      const queryParts = data.rules.map((rule) => {
        const operator = getConditionOperator(rule);

        if (!operator) {
          return '';
        }

        // Determine if finalVal needs quotation mark around it
        const finalVal = !isNaN(rule.conditionObject.value) && !isNaN(parseFloat(rule.conditionObject.value)) 
          ? rule.conditionObject.value // Dont add 'quote' around value
          : "'" + rule.conditionObject.value + "'"; // Add 'quote' quote around value

        return `${operator}${finalVal}`;
      });
    
      const separator = condition ? " OR " : " AND ";
      const queryStr = queryParts.filter(part => part).join(separator); // Filter out empty strings and then join

      return queryStr;
    } else {
      // Collection type: Manual
      const products = result.data.collections.nodes[0].products.edges;
      const product_ids = []
      products.forEach((product) => {
        product_ids.push(product.node.id.split("/").pop());
      });
      queryStr = "id:" + product_ids.join(" OR id:");

      return queryStr;
    }
  }
}

const renameColumn = (column) => {
  switch (column) {
    case "VARIANT_PRICE":
      return "price";
    case "TITLE":
      return "title";
    case "TYPE":
      return "product_type";
    case "VENDOR":
      return "vendor";
    case "TAG":
      return "tag";
    default:
      return false;
  }
};

const getConditionOperator = (rule) => {
  var filterName = renameColumn(rule.column);

  switch (rule.relation) {
    case "EQUALS":
      return `${filterName}:`;
    case "NOT_EQUALS":
      return `-${filterName}:`;
    case "GREATER_THAN":
      return `${filterName}:>=`;
    case "LESS_THAN":
      return `${filterName}:<=`;
  }

  return false;
};

const isRuleAvailable = (data) => {
  // Below collection condition cannot be used inside product's query
  const columnsToCheck = ["TITLE", "VARIANT_COMPARE_AT_PRICE", "VARIANT_WEIGHT", "VARIANT_TITLE"];
  const relationsToCheck = ["STARTS_WITH", "ENDS_WITH", "CONTAINS", "NOT_CONTAINS"];

  for (const rule of data) {
    if (columnsToCheck.includes(rule.column) || relationsToCheck.includes(rule.relation)) {
      return false;
    }
  }
  return true;
};

async function getProductTag(query = '') {
  // product status must be available and channel selected to be online store
  let fixedQuery = 'status:active AND published_status:published';
  let productData = [];

  if (query) {
    const queryStr = fixedQuery + ' AND ' + query;
    const productsQuery = `
      {
        products(
          query: "${queryStr}"
          first: 250
        ) {
          nodes {
            tags
          }
        }
      }
    `;

    const response = await fetch(GRAPHQLHOST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query: productsQuery }),
    });
    const result = await response.json();

    if (result.data.products.nodes.length) {
      result.data.products.nodes.forEach(v => {
        productData.push(v.tags);
      });
    }
  }

  return productData;
}

async function getProductCount(query = '') {
  // product status must be available and channel selected to be online store
  let fixedQuery = 'status:active AND published_status:published';

  const queryStr = fixedQuery + ' AND ' + query;
  const countQuery = `
    {
      productsCount(
        query: "${queryStr}"
      ) {
        count
      }
    }
  `;

  const response = await fetch(GRAPHQLHOST, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query: countQuery }),
  });
  const result = await response.json();

  return result.data.productsCount.count ? result.data.productsCount.count : 0;
}

function getMenuPriceRange() {
  document.querySelectorAll('.pa-dropdown-panel').forEach(async dropdown => {
    let priceRange = [];
    const rangeValue = dropdown.querySelector(".menu-slider-container .menu-price-slider");
    const rangeInputValue = dropdown.querySelectorAll('.menu-range-input input');

    if (dropdown.dataset.collection) {
      const collectionQuery = await getMenuCollectionConditions(dropdown.dataset.collection);
      let fixedQuery = 'status:active AND published_status:published';
  
      const queryStr = fixedQuery + (collectionQuery != '' ? ' AND ' + collectionQuery : '');
      const priceRangeQuery = `
        {
          products(
            query: "${queryStr}"
            first: 250
          ) {
            nodes {
              priceRange {
                maxVariantPrice {
                  amount
                }
                minVariantPrice {
                  amount
                }
              }
            }
          }
        }
      `;
  
      const response = await fetch(GRAPHQLHOST, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query: priceRangeQuery }),
      });
      const result = await response.json();
      const data = result.data.products.nodes;
      let temp = [];

      if (data.length) {
        data.forEach(v => {
          if (v.priceRange.minVariantPrice.amount)
            temp.push((v.priceRange.minVariantPrice.amount / 100));
          if (v.priceRange.maxVariantPrice)
            temp.push((v.priceRange.minVariantPrice.amount / 100));
        });

        priceRange = temp.filter((v, k, arr) => arr.indexOf(v) === k).sort((a, b) => a - b);

        initPriceSlider(dropdown);
        rangeInputValue[0].setAttribute('min', 0);
        rangeInputValue[0].setAttribute('value', priceRange[0]);
        rangeInputValue[0].setAttribute('max', priceRange[priceRange.length - 1]);
        rangeInputValue[0].min = 0;
        rangeInputValue[0].value = priceRange[0];

        rangeInputValue[1].setAttribute('min', 0);
        rangeInputValue[1].setAttribute('value', priceRange[priceRange.length - 1]);
        rangeInputValue[1].setAttribute('max', priceRange[priceRange.length - 1]);
        rangeInputValue[1].value = priceRange[priceRange.length - 1];
        rangeInputValue[1].max = priceRange[priceRange.length - 1];

        // rangeInputValue[0].dispatchEvent(new Event("change"));
        // rangeInputValue[1].dispatchEvent(new Event("change"));

        let minVal = priceRange[0];
        let maxVal = priceRange[priceRange.length -1];
        rangeValue.style.left = `${(minVal / rangeInputValue[0].max) * 100}%`;
        rangeValue.style.right = `${100 - (maxVal / rangeInputValue[1].max) * 100}%`;

        let eleTitle = dropdown.getAttribute('id').split('-');
        dropdown.querySelector('#pa-menu-label_' + eleTitle[eleTitle.length - 1] + '_budget').innerText = rangeInputValue[0].dataset.currency + priceRange[0] + ' - ' + rangeInputValue[1].dataset.currency + priceRange[priceRange.length - 1];
      }
    }
  });
}

function initPriceSlider(elem) {
  const rangeValue = elem.querySelector("#filter-budget .menu-slider-container .menu-price-slider");
  const rangeInputValue = elem.querySelectorAll("#filter-budget .menu-range-input input");

  let priceGap = 500;

  const priceInputValue = elem.querySelectorAll("#filter-budget .menu-price-input input");
  for (let i = 0; i < priceInputValue.length; i++) {
    priceInputValue[i].addEventListener("input", e => {
      let minp = parseInt(priceInputValue[0].value);
      let maxp = parseInt(priceInputValue[1].value);
      let maxValue = parseInt(priceInputValue[1].dataset.maxValue);
      let diff = maxp - minp

      if (minp < 0) {
        alert("minimum price cannot be less than 0");
        priceInputValue[0].value = 0;
        minp = 0;
      }

      if (maxp > maxValue) {
        alert("maximum price cannot be greater than " + maxValue);
        priceInputValue[1].value = maxValue;
        maxp = maxValue;
      }

      if (minp > maxp - priceGap) {
        priceInputValue[0].value = maxp - priceGap;
        minp = maxp - priceGap;

        if (minp < 0) {
          priceInputValue[0].value = 0;
          minp = 0;
        }
      }

      if (diff >= priceGap && maxp <= rangeInputValue[1].max) {
        if (e.target.className === "menu-min-input") {
          rangeInputValue[0].value = minp;
          let value1 = rangeInputValue[0].max;
          rangeValue.style.left = `${(minp / value1) * 100}%`;
        } else {
          rangeInputValue[1].value = maxp;
          let value2 = rangeInputValue[1].max;
          rangeValue.style.right = `${100 - (maxp / value2) * 100}%`;
        }
      }
    });

    for (let i = 0; i < rangeInputValue.length; i++) {
      rangeInputValue[i].addEventListener("input", e => {
        let minVal = parseInt(rangeInputValue[0].value);
        let maxVal = parseInt(rangeInputValue[1].value);

        let diff = maxVal - minVal

        let eleTitle = elem.getAttribute('id').split('-');
        elem.querySelector('#pa-menu-label_' + eleTitle[eleTitle.length - 1] + '_budget').innerText = rangeInputValue[i].dataset.currency + minVal + ' - ' + rangeInputValue[i].dataset.currency + maxVal;
        if (diff < priceGap) {
          if (e.target.className === "menu-min-range") {
            rangeInputValue[0].value = maxVal - priceGap;
          } else {
            rangeInputValue[1].value = minVal + priceGap;
          }
        } else {
          priceInputValue[0].value = minVal;
          priceInputValue[1].value = maxVal;
          rangeValue.style.left = `${(minVal / rangeInputValue[0].max) * 100}%`;
          rangeValue.style.right = `${100 - (maxVal / rangeInputValue[1].max) * 100}%`;
        }
      });

      rangeInputValue[i].addEventListener("change", async e => {
        showMenuPriceTagSelected();

        let count = await menuProductCount();
        // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
        // elem.querySelector('.pa-filter-btn').innerText = 'Show ' + count + (count > 1 ? ' items' : ' item');
        elem.querySelector('.pa-filter-btn').innerText = 'View results';
      });
    }
  }
}

function showMenuTagSelected(tag, label) {
  const dropdown = document.querySelector('.pa-dropdown-panel.pa-dropdown-on');
  const htmlElement = dropdown.querySelector('.filters-result');
  let correctFormatting = escapeTag(tag.toLowerCase()); // tag.toLowerCase().replaceAll(' ', '-').replaceAll(/\./g, '-').replaceAll('&', '\\&');

  let template = `<button type="button" class="pa_menu_filter_active__button collection__mobile-active-filter-item pa_menu_js_tag-${correctFormatting}" data-tag="${tag}">${label}
    <span class="collection__mobile-active-filter-cross">
      <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">
        <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
      </svg>
    </span>
  </button>`;
  htmlElement.insertAdjacentHTML('beforeend', template);
  dropdown.querySelector('.pa_menu_js_tag-' + correctFormatting).addEventListener('click', function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    dropdown.querySelector('.pa_menu_js_tag-' + correctFormatting).remove();

    const valueOnly = tag.split('_');
    const select = dropdown.querySelector('button[value*=\'' + valueOnly[valueOnly.length - 1] + '\']');
    select.classList.remove('active');

    if (select.classList.value.includes('series') || select.classList.value.includes('model')) {
      document.getElementById('pa-menu-label_' + select.dataset.type + '_series').innerText = '';
    } else {
      document.getElementById('pa-menu-label_' + select.dataset.type + '_' + select.classList[0].replace('pa-', '').replace('-btn', '')).innerText = '';
    }

    menuProductCount();
  });
}

function showMenuPriceTagSelected() {
  const dropdowns = document.querySelectorAll('.pa-dropdown-panel');

  dropdowns.forEach(dropdown => {
    const htmlElement = dropdown.querySelector('.filters-result');
    const minRange = dropdown.querySelector('#filter-budget .menu-range-input .menu-min-range');
    const maxRange = dropdown.querySelector('#filter-budget .menu-range-input .menu-max-range');
    const rangevalue = dropdown.querySelector(".menu-slider-container .menu-price-slider");

    if (minRange.value != minRange.min || maxRange.value != maxRange.max) {
      const existingTag = htmlElement.querySelector('.pa_menu_js_tag-budget');
      if (existingTag) {
        existingTag.remove();
      }
    
      let currency = '';
      if (minRange.dataset.currency) {
        currency = minRange.dataset.currency;
      }
    
      let newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('filter.v.price.lte');
      newUrl.searchParams.delete('filter.v.price.gte');
      let pricingTagTemplate = `<button type="button" class="pa_menu_filter_active__button collection__mobile-active-filter-item pa_menu_js_tag-budget">
          ${currency}${pricingFormat(parseFloat(minRange.value).toFixed(0))} - ${currency}${pricingFormat(parseFloat(maxRange.value).toFixed(0))}
          <span class="collection__mobile-active-filter-cross">
          <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">
            <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
        </span>
      </button>`;
    
      htmlElement.insertAdjacentHTML('beforeend', pricingTagTemplate);
      document.querySelector('.pa_menu_js_tag-budget').addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        document.querySelector('.pa_menu_js_tag-budget').remove();
        minRange.value = minRange.min;
        maxRange.value = maxRange.max;
    
        priceLabel.innerText = currency + minRange.value + ' - ' + currency + maxRange.value;
        rangevalue.style.left = `0%`;
        rangevalue.style.right = `100%`;
    
        menuProductCount();
      });
    }
  });
}

function columnNameConvert(column) {
  switch (column.toLowerCase()) {
    case 'type':
      return 'product_type';
      break;
    default:
      return column;
      break;
  }
}

function toggleDisableSeriesAndModel() {
  document.querySelectorAll('.pa-dropdown-panel').forEach(dropdown => {
    const selectedBrand = dropdown.querySelector('pa-brand-btn.active');

    if (!selectedBrand) {
      dropdown.querySelector('.pa-filter-series-container').classList.add('pa-disabled');
      dropdown.querySelector('.pa-filter-model-container').classList.add('pa-disabled');
      dropdown.querySelectorAll('.pa-disabled button').forEach(button => {
        button.setAttribute('disabled', 'disabled');
      });
    } else {
      dropdown.querySelectorAll('.pa-filter-series-container.pa-disabled button').forEach(button => {
        button.removeAttribute('disabled');
      });
      dropdown.querySelector('.pa-filter-model-container').classList.remove('pa-disabled');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  toggleDisableSeriesAndModel();

  document.addEventListener('click', function() {
    document.querySelectorAll('[data-dropdown="panel"]').forEach(v => {
      if (v.style.display != 'none') {
        v.style.display = 'none';
      }
    });
  });

  if (window.screen.width < 641) {
    document.querySelectorAll('.pa-dropdown-trigger').forEach((dropdown, k) => {
      dropdown.removeAttribute('data-type');
      const dropdownPanel = dropdown.nextElementSibling;

      if (dropdownPanel.classList.contains('pa-dropdown-panel')) {
        dropdownPanel.classList.remove('nav-dropdown');
        dropdownPanel.classList.remove('nav-dropdown--restrict');
        dropdownPanel.style.display = 'none';

        dropdownPanel.querySelector('.pa-close-container').addEventListener('click', () => {
          dropdownPanel.classList.remove('pa-dropdown-on');
          document.querySelector('html').style.overflow = 'auto';
          document.getElementById('shopify-section-multi-announcement-bar').style.display = 'block';
          menuHandler(k);
        });
      }

      dropdown.addEventListener('click', function() {
        dropdownPanel.classList.add('pa-dropdown-on');
        dropdownPanel.setAttribute('aria-hidden', 'false');
        document.querySelector('html').style.overflow = 'hidden';
        document.getElementById('shopify-section-multi-announcement-bar').style.display = 'none';
        menuHandler(k);
      });
    });
  } else {
    document.querySelectorAll('.pa-dropdown-trigger').forEach((dropdown, k) => {
      hideDropdown();
      
      function showDropdown() {
        dropdown.removeAttribute('data-type');
        dropdown.removeAttribute('aria-expanded');
        dropdown.nextElementSibling.classList.add('pa-dropdown-on');
        dropdown.nextElementSibling.removeAttribute('data-type');
        dropdown.nextElementSibling.style.display = 'block';
      }
      dropdown.addEventListener('mouseenter', showDropdown);
      dropdown.nextElementSibling.addEventListener('mouseenter', showDropdown);

      function hideDropdown() {
        dropdown.nextElementSibling.style.display = 'none';
        dropdown.nextElementSibling.classList.remove('pa-dropdown-on');
      }
      dropdown.addEventListener('mouseleave', hideDropdown);
      dropdown.nextElementSibling.addEventListener('mouseleave',hideDropdown);
      // dropdown.removeEventListener('mouseleave', hideDropdown);
    });
  }

  getMenuPriceRange();
});

function pricingFormat(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function escapeTag(tag) {
  return tag.replaceAll(' ', '-').replaceAll(/\./g, '-').replaceAll('"', '\"').replaceAll('&', '\\&').replaceAll(/[\)\(]/g, '');
}

function openTab(evt, tabName) {
  let tabNamePart = tabName.split('-');
  let tabNameType = tabNamePart[tabNamePart.length - 1];

  let tabContent = document.getElementsByClassName("pa_tab-content-link");
  for (let i = 0; i < tabContent.length; i++) {
    tabContent[i].style.display = "none";
    document.querySelector('.' + tabContent[i].getAttribute('id')).style.display = "none";
  }

  let tabLinks = document.getElementsByClassName("pa_tablinks");
  for (let i = 0; i < tabLinks.length; i++) {
    tabLinks[i].className = tabLinks[i].className.replace(" active", "");
  }

  document.getElementById(tabName).style.display = "block";
  document.querySelector('.' + tabName).style.display = "block";
  evt.currentTarget.className += " active";
}

/* Nav V1 */
document.addEventListener('DOMContentLoaded', function () {
  const dropdown = document.querySelectorAll('.nav-dropdown-left .nav-dropdown__item');

  dropdown.forEach(function (element) {
    const subnav_container = document.getElementById(element.getAttribute('data-menuid') + '_subnav_container');
    const subnav_section = document.getElementById(element.getAttribute('data-subnav'));
    const subnav_arrow = element.querySelector('.subnav-arrow');

    element.addEventListener('mouseenter', function () {
      element.classList.remove('nav-idle');
      if (!subnav_arrow) {
        return;
      }

      if (!subnav_section.innerHTML) {
        subnav_container.classList.remove('nav-visible');
        subnav_section.classList.remove('nav-visible');
        return;
      }

      subnav_container.classList.add('nav-visible');
      subnav_section.classList.add('nav-visible');
      subnav_section.addEventListener('mouseenter', function () {
        element.classList.remove('nav-idle');
        subnav_container.classList.add('nav-visible');
        subnav_section.classList.add('nav-visible');
      });
      subnav_section.addEventListener('mouseleave', function () {
        element.classList.add('nav-idle');
        subnav_container.classList.remove('nav-visible');
        subnav_section.classList.remove('nav-visible');
      });
    });

    element.addEventListener('mouseleave', function () {
      element.classList.add('nav-idle');
      if (!subnav_arrow) {
        return;
      }
      subnav_container.classList.remove('nav-visible');
      subnav_section.classList.remove('nav-visible');
    });

    // Handle subnav redirect only on 2nd subsequent clicks
    if (window.innerWidth < 640) {
      const link = element.querySelector('.subnav-left');
      let clicked = false;

      if (!link) {
        return;
      }

      link.addEventListener('click', function(event) {
        if (!clicked) {
          event.preventDefault();
        }
      });
      element.addEventListener('mouseenter', function () {
        setTimeout(function() {
          clicked = true;
        }, 100); // Make sure this process takes places after the click event
      });
      element.addEventListener('mouseleave', function () {
        clicked = false;
      });
    }
  });
});